import {Component, inject, input} from '@angular/core';
import {Rating, WineProduct} from '@core/interfaces/generated/graphql';

import {ProductRatingComponent} from '@layout/components/product/product-rating/product-rating.component';

import {CustomerReviewsAndWishlistService} from '@core/services/customer-reviews-and-wishlist.service';

@Component({
  selector: 'app-product-ratings',
  templateUrl: './product-ratings.component.html',
  styleUrls: ['./product-ratings.component.scss'],
  imports: [ProductRatingComponent]
})
export class ProductRatingsComponent {
  private customerReviewsAndWishlistService = inject(CustomerReviewsAndWishlistService);


  readonly product = input.required<WineProduct>();
  showCustomerRating = input<boolean>(true)
  customerRating: Rating|undefined;

  get ratings(): Rating[] {
    const ratings = this.product()?.meta?.ratings;
    if (!ratings) {
      return [];
    }
    return ratings.filter(d => !!d) as Rating[];
  }

  getCustomerReviewAsRating(product: WineProduct): Rating {
    if (!this.customerRating) {
      let customerReview = this.customerReviewsAndWishlistService.customerReviews().find(review => review?.product?.id === product.id);

      this.customerRating = {
        rating: customerReview?.rating ?? 0,
        starCount: 5,
        name: 'Din rating',
      };
    }
    return this.customerRating;
  }
}
